exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".delete-coupon-content[data-v-4e3016e4]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.delete-coupon-content .el-icon-question[data-v-4e3016e4]{font-size:24px;color:red}", ""]);

// exports
